import { render, staticRenderFns } from "./ProductSite.vue?vue&type=template&id=5e078358&scoped=true"
import script from "./ProductSite.vue?vue&type=script&lang=js"
export * from "./ProductSite.vue?vue&type=script&lang=js"
import style0 from "./ProductSite.vue?vue&type=style&index=0&id=5e078358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e078358",
  null
  
)

export default component.exports